import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserTableComponent } from './components/user-table/user-table.component';
import { KamRegionComponent } from './components/kam-region/kam-region.component';
import { LogTableComponent } from './components/log-table/log-table.component';
import { KamCustomersComponent } from './components/kam-customers/kam-customers.component';
import { RaitingDistributorComponent } from './components/raiting-distributor/raiting-distributor.component';
import { DistributorAgreementComponent } from './components/distributor-agreement/distributor-agreement.component';
import { GoodPriceComponent } from './components/good-price/good-price.component';
import { InnDependencyComponent } from './components/inn-dependency/inn-dependency.component';
import { SolocodeMappingComponent } from './components/solocode-mapping/solocode-mapping.component';
import { MnnStarComponent } from './components/project-mnn/project-mnn.component';



const routes: Routes = [
  {
    path: '',
    component: UserTableComponent
  },
  {
    path: 'import_user',
    component: UserTableComponent 
  },
  {
    path: 'kam-region',
    component: KamRegionComponent 
  },
  {
    path: 'kam-customers',
    component: KamCustomersComponent 
  },
  {
    path: 'raiting-distributor',
    component: RaitingDistributorComponent 
  },
  {
    path: 'distributor-agreement',
    component: DistributorAgreementComponent 
  },
  {
    path: 'good-price',
    component: GoodPriceComponent 
  },  
  {
    path: 'log',
    component: LogTableComponent 
  },
  {
    path: 'inn-dependency',
    component: InnDependencyComponent 
  },
  {
    path: 'solocode-mapping',
    component: SolocodeMappingComponent
  },
  {
    path: 'project-mnn',
    component: MnnStarComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/modules/user/importAndExportData-routing.module.ts